import { DATE_FORMAT } from '~constants'

export const DATE_MONTH_YEAR = `${DATE_FORMAT.SHORT_MM}-${DATE_FORMAT.SHORT_YEAR}`

export const NO_SHOW_TODAY = `No show today`

export const DATE_FORMATTER = {
  DAY: 'DD',
  DATE: 'MMM D',
  SHORT_DAY: 'ddd',
  TIME: 'h:mm A'
}

export const CALENDAR_EDP_NUMBER_OF_MONTHS = 36

export const CALENDAR_EDP_EVENTS_LIMIT = 5
